<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">Contents</p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample"><span class="epub-i">Title Page</span></span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample"><span class="epub-i">Copyright Notice</span></span></p>
<p class="toc"><a href="#/xhtml/ded#ded"><span class="epub-i">Dedication</span></a></p>
<p class="toc"><a href="#/xhtml/ack#ack"><span class="epub-i">Acknowledgments</span></a></p>
<p class="toc-bot"><a href="#/xhtml/intro#int"><span class="epub-i">Introduction</span></a></p>
<p class="toc"><a href="#/xhtml/part1#pt1"><span class="epub-b">Part One: First into the Great Basin</span></a></p>
<p class="toc"><a href="#/xhtml/chapter1#ch1">Chapter One • A “Dead” and “Rich” Land</a></p>
<p class="toc"><a href="#/xhtml/chapter2#ch2">Chapter Two • Enter the White Man</a></p>
<p class="toc"><a href="#/xhtml/chapter3#ch3">Chapter Three • Westward After Beaver</a></p>
<p class="toc"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">Chapter Four • Through “a Country of Starvation”</span></p>
<p class="toc"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">Chapter Five • “West, Ever West”</span></p>
<p class="toc-bot"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">Chapter Six • Frémont: Understanding the Great Basin</span></p>
<p class="toc"><span href="#/xhtml/part2#pt2" title="Link target outside of Sample"><span class="epub-b">Part Two: Land of the Latter-day Saint</span></span></p>
<p class="toc"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">Chapter Seven • Saints to the Great Basin</span></p>
<p class="toc"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">Chapter Eight • Brigham Young and Early Great Basin Days</span></p>
<p class="toc"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">Chapter Nine • Getting Settled in the Great Basin</span></p>
<p class="toc"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Chapter Ten • Polygamy: “Holy Seed unto the Lord”</span></p>
<p class="toc-bot"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">Chapter Eleven • The Utah War</span></p>
<p class="toc"><span href="#/xhtml/part3#pt3" title="Link target outside of Sample"><span class="epub-b">Part Three: The World Intrudes</span></span></p>
<p class="toc"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">Chapter Twelve • Roads into the Great Basin</span></p>
<p class="toc"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">Chapter Thirteen • Overland to Utah</span></p>
<p class="toc"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">Chapter Fourteen • The Rush to Washoe</span></p>
<p class="toc"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">Chapter Fifteen • Getting Ready for the Railroad</span></p>
<p class="toc-bot"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">Chapter Sixteen • Great Basin Epilogue: “It Is Done”</span></p>
<p class="toc"><span href="#/xhtml/note" title="Link target outside of Sample"><span class="epub-i">Notes</span></span></p>
<p class="toc"><span href="#/xhtml/bib" title="Link target outside of Sample"><span class="epub-i">Bibliography</span></span></p>
<p class="toc"><span href="#/xhtml/index" title="Link target outside of Sample"><span class="epub-i">Index</span></span></p>
<p class="toc"><span href="#/xhtml/adcard" title="Link target outside of Sample"><span class="epub-i">Also by Michael S. Durham</span></span></p>
<p class="toc"><span href="#/xhtml/copyright" title="Link target outside of Sample"><span class="epub-i">Copyright</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?94b7df9a